import { VacancyDetail } from '@/interfaces/vacancy'
import Script from 'next/script'

const StructuredDataJob = ({ vacancy }: { vacancy: VacancyDetail }) => {
  const day = vacancy.publicationStartDate?.substring(6, 8)
  const month = vacancy.publicationStartDate?.substring(4, 6)
  const year = vacancy.publicationStartDate?.substring(0, 4)
  const formattedDate = day + '-' + month + '-' + year

  const structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'JobPosting',
    title: vacancy.title ?? '',
    description: vacancy.shortDescription ?? '',
    employmentType: vacancy.jobType ?? '',
    hiringOrganization: {
      '@type': 'Organization',
      name: vacancy.relation ?? '',
      logo: vacancy.photoFileName ?? '',
    },
    datePosted: formattedDate ?? '',
    jobLocation: {
      '@type': 'Place',
      address: {
        '@type': 'PostalAddress',
        addressLocality: vacancy.location ?? '',
        streetAddress: vacancy.locationAddress ?? '',
        postalCode: vacancy.locationPostcode ?? '',
        addressCountry: vacancy.locationCountry ?? '',
      },
    },
    baseSalary: {
      '@type': 'MonetaryAmount',
      currency: vacancy.salaryUnit ?? 'EUR',
      value: {
        '@type': 'QuantitativeValue',
        value: vacancy.salaryValue ?? '',
        unitText: 'MONTH',
      },
    },
  }

  return (
    <Script
      id="structured-data"
      key="structured-data"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
}

export default StructuredDataJob
